var _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBtnAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 165,
    rx: 78.6777,
    fill: "#4D7AFF",
    fillOpacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#4D7AFF",
    fillOpacity: 0.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 54,
    width: 57.0413,
    height: 57.0413,
    rx: 28.5207,
    fill: "#4D7AFF",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#playBtnAudioID)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.8984 91.4943H80.3075V72.5625H74.8984V91.4943ZM85.7166 72.5625V91.4943H91.1257V72.5625H85.7166Z",
    fill: "#4D7AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "playBtnAudioID"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.4545,
    height: 32.4545,
    fill: "white",
    transform: "translate(66.7852 65.8008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtnAudio);
export default __webpack_public_path__ + "static/media/playBtnAudio.a7dc04e5813d4005f99755ad69ca2326.svg";
export { ForwardRef as ReactComponent };